export default __webpack_public_path__ + "static/media/Path 104.3cf29591.svg";